export default __webpack_public_path__ + "static/media/cemento-detalle.803642b7.png";